import type { VueI18nTranslation } from 'vue-i18n'
import type { SortingValue } from '@/types/catalog'

export const getBaseSortedOptions = (t: VueI18nTranslation): SortingValue[] => [
  {
    label: t('catalog.sorting_value_rated'),
    value: 'rating'
  },
  {
    label: t('catalog.sorting_value_lower_price'),
    value: 'price'
  },
  {
    label: t('catalog.sorting_value_high_price'),
    value: '-price'
  }
]

export const getBonusesSortOptions = (t: VueI18nTranslation): SortingValue[] => [
  {
    label: t('catalog.sorting_value_recommended'),
    value: 'o_recommended'
  },
  {
    label: t('catalog.sorting_new_first'),
    value: 'created_at'
  },
  {
    label: t('catalog.sorting_max_discount'),
    value: '-bonuses_percent'
  }
]

export const getSellerSortOptions = (t: VueI18nTranslation): SortingValue[] => [
  {
    label: t('catalog.sorting_new_first'),
    value: 'created_at'
  }
]
